import { render, staticRenderFns } from "./ProgramGenre.vue?vue&type=template&id=6c986106&scoped=true&"
import script from "./ProgramGenre.vue?vue&type=script&lang=js&"
export * from "./ProgramGenre.vue?vue&type=script&lang=js&"
import style0 from "./ProgramGenre.vue?vue&type=style&index=0&id=6c986106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c986106",
  null
  
)

export default component.exports